import { getFontSized } from "@tamagui/get-font-sized";
import { Text, styled } from "@tamagui/web";
const SizableText = styled(Text, {
  name: "SizableText",
  fontFamily: "$body",
  variants: {
    size: getFontSized
  },
  defaultVariants: {
    size: "$true"
  }
});
export {
  SizableText
};
//# sourceMappingURL=SizableText.js.map
